(function() {
    'use strict';

    var passwordRevealers = document.querySelectorAll('[gr-password-revealer]');

    if (!passwordRevealers) {
        return;
    }

    for (var i = 0; i < passwordRevealers.length; i++) {
        passwordRevealers[i].addEventListener('click', function() {
            var input = this.parentNode.querySelector('input[name="' + this.getAttribute('gr-password-revealer-name') + '"]');

            if (this.classList.contains('is-revealed')) {
                this.classList.remove('is-revealed');
                input.setAttribute('type', 'password');
            } else {
                this.classList.add('is-revealed');
                input.setAttribute('type', 'text');
            }
        });
    }
})();
